import * as actionTypes from './actionTypes';

export const initIncomes = (payload) => ({ type: actionTypes.INITIALIZE, payload });

export const submitIncomes = (payload) => ({ type: actionTypes.SUBMIT, payload });
export const submitIncomesSuccess = (payload) => ({ type: actionTypes.SUBMIT_SUCCESS, payload });
export const submitIncomesFailure = (error) => ({ type: actionTypes.SUBMIT_FAILURE, error });

export const getPropertyObjects = (payload) => ({ type: actionTypes.PROPERTY_OBJECTS, payload });
export const getPropertyObjectsSuccess = (payload) => ({
  type: actionTypes.PROPERTY_OBJECTS_SUCCESS,
  payload,
});
export const getPropertyObjectsFailure = (error) => ({
  type: actionTypes.PROPERTY_OBJECTS_FAILURE,
  error,
});
